import { useRiskProfileQuery } from './useRiskProfileQuery'
import type { RiskProfileQueryParams } from './useRiskProfileQueryParams'
import { useRiskProfileRequest } from './useRiskProfileRequest'

export function useProfileAreaData(queryParams: RiskProfileQueryParams | null) {
  const request = useRiskProfileRequest({ queryParams, widget: 'riskByArea' })
  const queryRequest =
    request &&
    (request.group_by === 'region' ||
      (typeof request.group_by === 'object' &&
        ('hazard_group' in request.group_by || 'element_group' in request.group_by)))
      ? (request as Parameters<typeof useRiskProfileQuery>[0])
      : null

  const query = useRiskProfileQuery(queryRequest)
  return { request, query }
}
